import { IconTypes } from '@eika/icon';
import { type CreateShareSavingsAccountForChildProcess, ProcessStatus } from '@generated-types';
import type { PendingProcessConfigType } from '@translation-utils/translation-type';
import { hasPendingKYCConsent, isComplete, isWaitingForApproverParentConsent } from '@utils/process-utils';
import { ProcessStep } from './types';

export const getActiveStep = (process: CreateShareSavingsAccountForChildProcess) => {
    if (isWaitingForApproverParentConsent(process)) {
        return ProcessStep.WAITING_FOR_APPROVER_PARENT_CONSENT;
    }

    if (hasPendingKYCConsent(process)) {
        return ProcessStep.REGISTERED;
    }

    if (isComplete(process)) {
        return ProcessStep.COMPLETE;
    }

    return ProcessStep.REGISTERED;
};

export const getIconFirstStep = ({ processStatus }: CreateShareSavingsAccountForChildProcess) => {
    switch (processStatus) {
        case ProcessStatus.PENDING_KYC_CONSENT:
            return IconTypes.MER_24;
        case ProcessStatus.PENDING_KYC_ADVISOR_REVIEW:
            return IconTypes.STOPP_24;
        default:
            return IconTypes.FAKTURA_24;
    }
};

export const getLabelFirstStep = (
    { processStatus }: CreateShareSavingsAccountForChildProcess,
    pendingProcess: PendingProcessConfigType,
) => {
    switch (processStatus) {
        case ProcessStatus.PENDING_KYC_CONSENT:
            return pendingProcess.progress.started;
        case ProcessStatus.PENDING_KYC_ADVISOR_REVIEW:
            return pendingProcess.progress.stopped;
        default:
            return pendingProcess.progress.registered;
    }
};

export const getLabelSecondStep = (
    process: CreateShareSavingsAccountForChildProcess,
    pendingProcess: PendingProcessConfigType,
) =>
    isWaitingForApproverParentConsent(process)
        ? pendingProcess.progress.waitingForApproverParent
        : pendingProcess.progress.consent;
